import {
  PortfolioLoanRecordStatusCode,
  PortfolioLoanStatusCode
} from '../components/HbtPortfolioManagementRequestOverview/api/types';
import { TranslationType } from '../components/HbtPortfolioManagementTable/types';

export const getPortfolioLoanStatusName = (code: string | undefined): string | undefined => {
  if (!code) return '';
  return Object.keys(PortfolioLoanRecordStatusCode).find(
    (key: string) =>
      PortfolioLoanRecordStatusCode[key as keyof typeof PortfolioLoanRecordStatusCode] === code
  );
};

export const getPortfolioLoanStatusCodeName = (code: string | undefined): string | undefined => {
  if (!code) return '';
  return Object.keys(PortfolioLoanStatusCode).find(
    (key: string) => PortfolioLoanStatusCode[key as keyof typeof PortfolioLoanStatusCode] === code
  );
};

export const getPortfolioLoanStatusDisplayName = (
  code: string | undefined,
  t: TranslationType
): string | undefined => {
  if (!code) return '';
  const statusMap: Record<string, string> = {
    PASS: t('Passed'),
    REVIEW: t('Review-Required'),
    FAIL: t('Failed'),
    DELETE: t('Deleted')
  };
  return statusMap[code] || code;
};

export const getPortfolioLoanStatusCode = (
  code: string | undefined,
  t: TranslationType
): string | undefined => {
  if (!code) return '';
  const statusMap: Record<string, string> = {
    Entered: t('Entered'),
    Received: t('Received'),
    Cancelled: t('Cancelled'),
    Rejected: t('Rejected'),
    Refused: t('Refused'),
    Withdrawn: t('Withdrawn'),
    Approved: t('Approved'),
    Issued: t('Issued'),
    Risked: t('Risked'),
    Finalized: t('Finalized'),
    Saved: t('Saved'),
    Priced: t('Priced'),
    Offer: t('Offer'),
    Lock: t('Lock'),
    Expired: t('Lock'),
    New: t('New'),
    Rerisk: t('Rerisk'),
    Critical: t('Rerisk')
  };
  return statusMap[code] || code;
};
